module.exports = __webpack_public_path__ + "img/WaterSplash.f2b2da37.png";